import { decryptData } from '@/app/helpers/crypto.util';
import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, inject, ViewRef } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, UnaryFunction } from 'rxjs';

export const CONTENT_TYPE = 'application/json';
export const REQUEST_TIMEOUT_IN_SECONDS = '30';
export const AUTH_STORE_KEY = 'accesstoken.sms.cookie.store.key';
export const USER_ROLE_STORE_KEY = 'accesstoken.user.role.cookie.store.key';
export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 10;
export const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

export function getHttpHeaders(): HttpHeaders {
  try {
    const storedData = localStorage.getItem(AUTH_STORE_KEY);
    if (!storedData) {
      return new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    let authInfo: any;

    if (storedData.trim().startsWith('{') && storedData.trim().endsWith('}')) {
      authInfo = JSON.parse(storedData);
    } else {
      authInfo = decryptData(storedData);      
    }

    const token = authInfo?.access_token;
    const tokenType = authInfo?.token_type || 'Bearer';

    return token
      ? new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `${tokenType} ${token}`
        })
      : new HttpHeaders({ 'Content-Type': 'application/json' });

  } catch (error) {
    console.error('Error parsing auth data:', error);
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }
}


export function takeUntilDestroy$<T>(): UnaryFunction<Observable<T>, Observable<T>> {
    const viewRef = inject(ChangeDetectorRef) as ViewRef;
    const destroyer$ = new ReplaySubject<void>(1);
    viewRef.onDestroy(() => destroyer$.next())
    return (observable: Observable<T>) => observable.pipe(takeUntil(destroyer$));
  }
  